<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="generalForm.site_name"
          label="App Name"
          :error-messages="errors.getMessage('site_name')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="generalForm.phone"
          label="Phone"
          :error-messages="errors.getMessage('phone')"
        />
      </v-col>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="generalForm.address_1"
          label="Address 1"
          :error-messages="errors.getMessage('address_1')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="generalForm.address_2"
          label="Address 2 (optional)"
          :error-messages="errors.getMessage('address_2')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="generalForm.address_3"
          label="Address Line 3 (optional)"
          :error-messages="errors.getMessage('address_3')"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="generalForm.logoWidth"
          label="Logo width"
          :error-messages="errors.getMessage('logoWidth')"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="generalForm.logoHight"
          label="Logo Hight"
          :error-messages="errors.getMessage('logoHight')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-select
          v-model="generalForm.dateFormat"
          clearable
          :items="dateFormats"
          label=" Date Time Format"
          :error-messages="errors.getMessage('dateFormat')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="generalForm.symbol"
          label=" Currency Symbol"
          :error-messages="errors.getMessage('symbol')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-checkbox
          v-model="generalForm.symbolOnLeft"
          class="mx-2"
          label="Symbol On Left"
        />
        <v-checkbox
          v-model="generalForm.spaceBetweenAmountAndSymbol"
          class="mx-2"
          label="Space Between Amount And Symbol"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-checkbox
          v-model="generalForm.rtl"
          class="mx-2"
          label="RTL Mode"
        />
        <v-checkbox
          v-model="generalForm.theme"
          class="mx-2"
          label="Dark Theme"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-slider
          v-model="generalForm.volume"
          max="10"
          min="0"
          vertical
          label="Notification volume"
          thumb-label="always"
        />
      </v-col>
      <v-col
        cols="12"
        class="pt-0 mt-0"
      >
        <div
          class="btn text-center"
          @click="hideOwnerInfo = !hideOwnerInfo"
        >
          <v-btn icon>
            <v-icon>mdi-unfold-less-horizontal</v-icon>
          </v-btn>
        </div>
        <template v-if="hideOwnerInfo">
          <v-col cols="12">
            <v-text-field
              v-model="generalForm.ownnerInfo"
              outlined
              clearable
              dense
              prepend-inner-icon="mdi-white-balance-sunny"
              type="password"
              placeholder="Enter onwer info license key to remove owner info (or buy via info.codehas@gmail.com) "
              label="Unlock owner info (optional)"
              messages="INFO : If you need to hide or remove owner information from your billing slips or invoices, need to purchase info removel key from author via info.codehas@gmail.com. (Price not included in purchase amount)"
            />
          </v-col>
        </template>
      </v-col>
    </v-row>

    <v-row>
      <v-btn
        class="info"
        @click="generalUpdate"
      >
        Update
      </v-btn>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      hideOwnerInfo: false,
      dateFormats: [
        "d-m-Y",
        "Y-m-d",
        "d-m-Y h:s:i",
        "d-m-Y, h:s:i",
        "Y-m-d h:s:i",
        "Y-m-d, h:s:i",
        "d D M Y",
        "Y M D d",
        "d D M Y, h:s:i",
        "d D M Y h:s:i",
        "Y M D d, h:s:i",
        "Y M D d h:s:i",
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      generalForm: "configs/general",
    }),
  },

  methods: {
    generalUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-general-update",
        payload: this.generalForm,
      });
    },
  },
};
</script>
